
import { CarouselItem, Form } from "element-ui";
import { BgFormItem } from "@banggood/scm-fe";
import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import { PONItem, CartonSizeItem } from "./definitions";
import {
  createCartonSizeItem,
  isQuantityValue,
  isPositiveWeight,
} from "./utils";
import { scrollElementFormErrorIntoView } from "@/utils";
@Component({
  components: {
    BgFormItem,
  },
})
export default class EncasementForm extends Vue {
  @Ref("form") form!: Form;
  @Prop({ required: false, default: false }) readonly?: boolean;
  formData: {
    PONItems: PONItem[];
  } = {
    PONItems: [],
  };
  cartonSizeItemParentMap: Map<CartonSizeItem, PONItem> = new Map();
  get cartonSizeRules() {
    const sizeValidator = (
      rules: unknown,
      value: number | string,
      callback: (msg?: string) => void
    ) => {
      const val = String(value);
      if (val && !/^[+]?\d+(\.\d{1,2})?$/.test(val)) {
        callback("请输入有效数值,保留最多2位小数");
      } else {
        callback();
      }
    };
    const quantityValidator = (
      rules: unknown,
      value: number | string,
      callback: (msg?: string) => void
    ) => {
      const val = String(value);
      if (val && !/^[+]?\d+$/.test(val)) {
        callback("请输入正整数");
      } else {
        callback();
      }
    };
    return {
      length: [
        { required: !this.readonly, message: "请输入最长边", trgger: "blur" },
        {
          validator: sizeValidator,
          trigger: "blur",
        },
      ],
      width: [
        { required: !this.readonly, message: "请输入次长边", trgger: "blur" },
        {
          validator: sizeValidator,
          trigger: "blur",
        },
      ],
      height: [
        { required: !this.readonly, message: "请输入最短边", trgger: "blur" },
        {
          validator: sizeValidator,
          trigger: "blur",
        },
      ],
      perBoxQuantity: [
        {
          required: !this.readonly,
          message: "请输入单箱产品个数",
          trgger: "blur",
        },
        {
          validator: quantityValidator,
          trigger: "blur",
        },
      ],
      boxQuantity: [
        {
          required: !this.readonly,
          message: "请输入分装箱子数量",
          trgger: "blur",
        },
        {
          validator: quantityValidator,
          trigger: "blur",
        },
      ],
      outerBoxGrossWeight: [
        {
          required: !this.readonly,
          message: "请输入整箱毛重",
          trgger: "blur",
        },
      ],
      outerBoxNetWeight: [
        {
          required: !this.readonly,
          message: "请输入整箱净重",
          trgger: "blur",
        },
      ],
    };
  }
  tableSpanMethod(conf: {
    row: CartonSizeItem;
    rowIndex: number;
    columnIndex: number;
  }) {
    const quantityColIndex = 1;
    const totalQuantityColIndex = 9;
    if (
      conf.columnIndex === quantityColIndex ||
      conf.columnIndex === totalQuantityColIndex
    ) {
      const parent = this.cartonSizeItemParentMap.get(conf.row);
      if (parent && conf.rowIndex === 0) {
        return [parent.cartonSizeList.length, 1];
      } else {
        return [0, 0];
      }
    } else {
      return [1, 1];
    }
  }
  getFormData() {
    return this.formData.PONItems;
  }
  setFormData(ponItems: PONItem[]) {
    this.formData.PONItems = ponItems;
    const parentMap: Map<CartonSizeItem, PONItem> = new Map();
    this.formData.PONItems.forEach((ponItem) => {
      ponItem.cartonSizeList.forEach((cartonSizeItem) => {
        parentMap.set(cartonSizeItem, ponItem);
      });
    });
    this.cartonSizeItemParentMap = parentMap;
  }
  getCartonSizeItemsTotalQuantity(ponItem: PONItem) {
    let sum: number | null = null;
    ponItem.cartonSizeList.forEach((item) => {
      if (
        isQuantityValue(item.perBoxQuantity) &&
        isQuantityValue(item.boxQuantity)
      ) {
        const perBoxQuantity = Number(item.perBoxQuantity);
        const boxQuantity = Number(item.boxQuantity);
        const res = perBoxQuantity * boxQuantity;
        if (sum === null) {
          sum = 0;
        }
        sum += res;
      }
    });
    return sum;
  }
  addCartonSize(ponItemIndex: number, index: number) {
    const ponItem = this.formData.PONItems[ponItemIndex];
    const ref = ponItem.cartonSizeList[ponItem.cartonSizeList.length - 1];
    const newCartonSize = createCartonSizeItem(ref);
    const newIndex = index + 1;
    ponItem.cartonSizeList.splice(newIndex, 0, newCartonSize);
    this.$nextTick(() => {
      this.clearCartonSizeValidate(ponItemIndex, newIndex);
    });
  }
  removeCartonSize(ponItemIndex: number, index: number) {
    const ponItem = this.formData.PONItems[ponItemIndex];
    this.clearCartonSizeValidate(ponItemIndex, index);
    this.$nextTick(() => {
      ponItem.cartonSizeList.splice(index, 1);
    });
  }
  clearCartonSizeValidate(ponItemIndex: number, index: number) {
    const ponItem = this.formData.PONItems[ponItemIndex];
    const cartonSize = ponItem.cartonSizeList[index];
    if (!cartonSize) {
      return;
    }
    const fields = [
      `PONItems.${ponItemIndex}.cartonSizeList.${index}.length`,
      `PONItems.${ponItemIndex}.cartonSizeList.${index}.width`,
      `PONItems.${ponItemIndex}.cartonSizeList.${index}.height`,
      `PONItems.${ponItemIndex}.cartonSizeList.${index}.perBoxQuantity`,
      `PONItems.${ponItemIndex}.cartonSizeList.${index}.boxQuantity`,
      `PONItems.${ponItemIndex}.cartonSizeList.${index}.outerBoxGrossWeight`,
      `PONItems.${ponItemIndex}.cartonSizeList.${index}.outerBoxNetWeight`,
    ];
    this.form.clearValidate(fields);
    console.log("this.form", this.form);
  }
  async validate() {
    if (this.readonly) {
      return true;
    }
    let valid = await this.form.validate().catch(() => false);
    if (!valid) {
      return false;
    }
    const allRows = this.formData.PONItems.flatMap(
      (item) => item.cartonSizeList
    );
    const hasInvalidWeight = allRows.some(
      (row) =>
        !isPositiveWeight(row.outerBoxGrossWeight) ||
        !isPositiveWeight(row.outerBoxNetWeight)
    );
    if (hasInvalidWeight) {
      this.$message.warning("重量存在非正数值，请修改后提交");
      return false;
    }
    const hasGrossNotGreaterThanNet = allRows.some(
      (row) => Number(row.outerBoxGrossWeight) <= Number(row.outerBoxNetWeight)
    );
    if (hasGrossNotGreaterThanNet) {
      this.$message.warning("毛重<净重，请修改后提交");
      return false;
    }
    const quantityEqual = this.formData.PONItems.every((PONItem) =>
      PONItem.cartonSizeList.every(
        (cartonSize) =>
          cartonSize.quantity === this.getCartonSizeItemsTotalQuantity(PONItem)
      )
    );
    if (valid && !quantityEqual) {
      this.$message.warning("装箱总数量不等于发货数量，请确认后再提交");
      valid = false;
    }
    return valid;
  }
  scrollErrorIntoView() {
    scrollElementFormErrorIntoView(this.form);
  }
}
